import LayoutActividad from "../../../components/LayoutActividad";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSignLanguage } from "@fortawesome/free-solid-svg-icons";
import { modulo6 } from "../../../routes/Module6";
import { modulo7 } from "../../../routes/Module7";
import Imagen1 from "../../../images/modulo6/escudopintar.png";
import Sidebar from "../Sidebar";
import GuiaDocente from "../../../components/GuiaDocente";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo6/Actividad 9.mp3";

const Actividad9 = () => {
  const infoUnidad = modulo6.content[0];
  const infoAct = modulo6.content[0].activities[8];
  const crumbs = [
    {
      title: modulo6.title,
      url: "/" + modulo6.url,
    },
    {
      title:
        modulo6.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titlePrev: `${modulo6.content[0].activities[7].name}`,
    linkPrev: `${modulo6.url}/${modulo6.content[0].path}/${modulo6.content[0].activities[7].path}`,
  };
  const metadata = {
    color: modulo6.color,
    title: `${modulo6.title} - ${infoAct.name}`,
    name: modulo6.title,
  };
  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo6.color} hat-text`}>
          <FontAwesomeIcon icon={faSignLanguage} /> Hacemos
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
      <AudioPlayer track={Audio} />

      <ul className="mb-0">
        <li>
          Crea un nuevo escudo para el Perú en una hoja. Puedes descargar la
          imagen de abajo como base para tu ilustración.
        </li>
        <li>
          El escudo debe incluir elementos que consideramos importantes en la
          actualidad.{" "}
        </li>
        <li>
          Luego de crear el escudo, explica a un compañero, compañera o familiar
          por qué lo hiciste de esa manera.{" "}
        </li>
      </ul>

      <div className="row align-items-center mb-4 ms-md-3 ms-0">
        <div className="col-lg-8 col-12 text-center">
          <img src={Imagen1} alt="Comic" className="img-fluid" />
        </div>
      </div>

      <GuiaDocente>
        <p>
          Lea las indicaciones. Conversen brevemente acerca de posibles
          elementos a incluir en el escudo.
        </p>
      </GuiaDocente>
      <div className="unit-options my-5 d-flex flex-column">
        <p>Ir al siguiente módulo:</p>
        <a href={"/" + modulo7.url}>
          <button className={`btn btn-${modulo6.color} me-2`}>
            {modulo7.title + " >"}
          </button>
        </a>
      </div>
    </LayoutActividad>
  );
};

export default Actividad9;
